import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from '@auth0/auth0-angular';
import { MsalModule, MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { LayoutComponent } from './layout/layout.component';
import { NavbarComponentComponent } from './layout/navbar/navbar-component/navbar-component.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { LoginComponent } from './login/login.component';
import { LoginWithoutCaptchaComponent } from './loginWithoutCaptcha/login-without-captcha.component';
import { MaterialModule } from './materialComponents/material.module';
import { SharedModule } from './shared/shared.module';
import { ReusableComponentsModule } from './ReusableComponents/reusable-components.module';
import { AlertDialogComponent } from './utility/alert-dialog/alert-dialog.component';
import { CountdownAlertComponent } from './utility/countdown-alert/countdown-alert/countdown-alert.component';
import { PromptDialogComponent } from './utility/prompt-dialog/prompt-dialog.component';
import { RestoreCreatePromptComponent } from './utility/restore-create-prompt/restore-create-prompt.component';
import { constant } from './constant/constant';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    SidebarComponent,
    LoginComponent,
    PromptDialogComponent,
    AlertDialogComponent,
    CountdownAlertComponent,
    LoginWithoutCaptchaComponent,
    NavbarComponentComponent,
    RestoreCreatePromptComponent,
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    FlexLayoutModule,
    MaterialModule,
    ReusableComponentsModule,
    // StoreConfiguratorModule,
    // EdiModule,
    MatTableModule,
    ScrollingModule,
    MatSelectModule,
    NgxUiLoaderModule,
    NgxUiLoaderRouterModule,
    NgIdleKeepaliveModule.forRoot(),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
    }),
    MatButtonModule,
    MatIconModule,
    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatInputModule,
    AuthModule.forRoot({
      domain: environment.domain,
      clientId: environment.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: environment.audience
      }
    }),
    MsalModule],
  providers: [
    [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: MSAL_INSTANCE,
      useFactory: (): IPublicClientApplication => {
        return new PublicClientApplication({
          auth: {
            clientId: constant.AZURE_MSAL_CLIENT_ID,
            authority: constant.AZURE_MSAL_AUTHORITY,
            redirectUri: `${window.location.origin}/azureoauthresponse`
          },
          cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage
          }
        });
      }
    },
    MsalService,
  ]
})

export class AppModule { }
